import { render } from "./SetTvaModal.vue?vue&type=template&id=46e0fe98&ts=true"
import script from "./SetTvaModal.ts?vue&type=script&lang=ts"
export * from "./SetTvaModal.ts?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/RC.Estimatifs/rc-estimatifs-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__